import CompositionService from "../services/composition.service";

export const compositions = {
  namespaced: true,
  actions: {
    getCompositions({ }, params = {}) {
      return CompositionService.getCompositions(params)
        .then(
          (resp) => Promise.resolve(resp),
          (error) => Promise.reject(error)
        )
        .catch((e) => Promise.reject(e));
    },
    getCompositionById({ }, id) {
      return CompositionService.getCompositionById(id)
        .then(
          (resp) => Promise.resolve(resp),
          (error) => Promise.reject(error)
        )
        .catch((e) => Promise.reject(e));
    },
  },
  mutations: {},
  getters: {},
};
